// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Tooltip_overlay__3In1Z","tooltip":"Tooltip_tooltip__8_eU8","dark":"Tooltip_dark__17uom","show":"Tooltip_show__3oE11"};